"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createCrosshair;
function createCrosshair(plot) {
  var crosshair = {};
  var crosshairContainer = plot.foreground().append('g').style('visibility', 'hidden');
  crosshair.vLine = crosshairContainer.append('line').attr('stroke', 'black').attr('y1', 0).attr('y2', plot.height());
  crosshair.circle = crosshairContainer.append('circle').attr('stroke', 'black').attr('fill', 'white').attr('r', 3);
  crosshair.height = function (h) {
    crosshair.vLine.attr('y2', h);
  };
  crosshair.drawAt = function (p) {
    crosshair.vLine.attr('x1', p.x).attr('x2', p.x);
    crosshair.circle.attr('cx', p.x).attr('cy', p.y);
    crosshairContainer.style('visibility', 'visible');
  };
  crosshair.hide = function () {
    crosshairContainer.style('visibility', 'hidden');
  };
  return crosshair;
}
//# sourceMappingURL=createCrosshair.js.map